import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'brightside-web-account-header',
    templateUrl: './account-header.component.html',
    styleUrls: ['./account-header.component.scss'],
    standalone: false
})
export class AccountHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() balance: number;
  @Input() imageUrl: string;
  @Input() balanceLabelKey = 'ACCOUNT_HOME_CURRENT_BALANCE';

  constructor() {}

  ngOnInit(): void {}
}
